import { styled } from 'linaria/react';

export const UserWithLoyaltyWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;

  width: fit-content;
  border: 1px solid var(--control-minor);
  border-radius: 100px;
`;
